import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppService } from '../../Services/app.service';

@Component({
  selector: 'app-project-management',
  templateUrl: './project-management.component.html'
})

export class ProjectManagementComponent implements OnInit {

  title!: string;
  breadcrumbConfig: object = {
    lastLinkColor: '#5B616E',
    symbol: ' / ',
  };

  navMenuName: any;

  constructor(
    private appService: AppService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.appService.getTitle().subscribe((data) => {
      this.title = data;
      this.cdr.detectChanges();
    });
  }
}
